import React from 'react';
import {WithTranslationProps} from 'react-i18next';
import {get} from 'lodash';

import SectionHeader from '/component/base/SectionHeader';
import {withTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
interface LoadingData {
  total: number;
}

interface ReportMeta {
  page: {
    total: number;
  };
}

interface ClientsListHeaderProps extends WithTranslationProps {
  loadingData: LoadingData | null;
  reportMeta: ReportMeta | null;
  reportName: string;
  reportIsLoading: boolean;
}

export const ClientsListHeader: React.FC<ClientsListHeaderProps> = ({
  tt = withTranslation.ttDefaultProp,
  loadingData = null,
  reportMeta = null,
  reportName = '',
  reportIsLoading = true,
}) => {
  const loadingDataTotal = get(loadingData, 'total', '');

  let total = get(reportMeta, 'page.total', get(loadingData, 'total', ''));

  if (loadingDataTotal > total) {
    total = loadingDataTotal;
  }

  return (
    <SectionHeader
      reportName={reportName}
      reportIsLoading={reportIsLoading}
      reportMeta={reportMeta}
      allowFontScaling
      maxFontSizeMultiplier={2}>
      {tt(
        'totalClientsCount',
        generateComponentCallback({
          component: (
            <>
              {total} {total === 1 ? 'Client' : 'Clients'}
            </>
          ),
        }),
      )}
    </SectionHeader>
  );
};

export default withTranslation('report.list.clientsHeader')(ClientsListHeader);
